export default "__VITE_ASSET__74d5c50e__"